import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-data-setup-common-content',
  templateUrl: './data-setup-common-content.component.html',
  styleUrl: './data-setup-common-content.component.scss'
})
export class DataSetupCommonContentComponent {
  @Input() isIos: boolean;
  @Input() isTmo: boolean;
  @Input() isGeneration: boolean = false;


}
